import IconCrossSmall from '@picsart/icons/IconCrossSmall';
import { useEffect, useState } from 'react';
import { useTranslator } from '@picsart/rc/services/localization';
import classNames from 'classnames';
import noop from '@picsart/rc/noop';

import Cookies from 'services/wrappers/cookies';
import Modal from 'components/common/Modal';

import useStyles from './styles';
import { IInfoPopupData } from './types';

interface IInfoPopupProps {
  data: IInfoPopupData;
  isGeneralMessage?: boolean;
  onAnalytics?: () => void;
}

const InfoPopup = ({
  data: {
    id,
    cookieName,
    slides,
    buttonName,
  },
  onAnalytics = noop,
  isGeneralMessage = true,
}: IInfoPopupProps) => {
  const classes = useStyles();
  const translate = useTranslator();
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const slide = slides[currentIndex];
  const isLast = currentIndex === slides.length - 1;

  const handleClick = () => {
    if (isLast) {
      setOpen(false);
      onAnalytics();
    } else {
      setCurrentIndex(prev => prev + 1);
    }
  };

  useEffect(() => {
    if (!isGeneralMessage) {
      const infoPopupId = Cookies.get(cookieName);

      if (infoPopupId !== id) {
        Cookies.set(cookieName, id);
      }
    }
  }, [isGeneralMessage, cookieName, id]);

  return open && slide ? (
    <Modal>
      <div className={classes.topWrapper} data-testid="top-wrapper">
        <div className={classes.imgWrapper}>
          <img src={slide.src} alt="img" key={slide.title} className={classes.img} />
        </div>
        <button onClick={() => setOpen(false)} data-testid="close-id">
          <IconCrossSmall className={classes.closeIcon} />
        </button>
        <div
          className={classes.textWrapper}
        >
          <p className={classes.title}>{translate(slide.title)}</p>
          <p className={classes.text}>{translate(slide.text)}</p>
        </div>
        {slides.length > 1 && (
          <div className={classes.indicatorsWrapper}>
            {slides.map((item, index) => (
              <button
                className={classNames(classes.indicatorButton, {
                  [classes.activeIndicatorButton]: index === currentIndex,
                })}
                aria-label="text"
                key={item.title}
                data-testid={item.title}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        )}
        <button
          className={classes.infoButton}
          data-testid="info-button"
          onClick={handleClick}
        >
          {isGeneralMessage ? translate(isLast ? 'Got It' : 'Next') : translate(buttonName as string)}
        </button>
      </div>
    </Modal>
  ) : null;
};

export default InfoPopup;
